(()=>{

   let wpcf7Elmnts = document.querySelectorAll( '.wpcf7' );

   [].forEach.call( wpcf7Elmnts, function(wpcf7Elm) {

      let responseOutput = wpcf7Elm.querySelector('.wpcf7-response-output'),
      form = wpcf7Elm.querySelector('.wpcf7-form');
   
    wpcf7Elm.addEventListener( 'wpcf7invalid', errorHandler);
    wpcf7Elm.addEventListener( 'wpcf7spam', errorHandler);
    wpcf7Elm.addEventListener( 'wpcf7mailfailed', errorHandler);
      wpcf7Elm.addEventListener( 'wpcf7mailsent', sentHandler);
   
      wpcf7Elm.addEventListener( 'submit', function( event ) {
         responseOutput.style.opacity = 1;
         responseOutput.style.display='block';
         form.classList.add('loading');
        
      } );

      function sentHandler( event ) {
         
          form.classList.remove('loading');
      }

      function errorHandler( event ) {

        let errormessage = responseOutput;
        errormessage.style.opacity = 1;
         form.classList.remove('loading');
        // responseOutput.classList.remove('loading');

        errormessage.addEventListener( 'click', hide );
          setTimeout( hide, 3000 );

          function hide () {
              
            errormessage.style.opacity = 0;
            setTimeout(()=>{
              errormessage.style.display = 'none';
              errormessage.style.opacity = 1;
            },500);
          }
      }
   });

})();
